// src/App.js
import React from 'react';
import { Outlet } from 'react-router-dom';
import Navbar from './components/Navbar';
import Sidebar from './components/Sidebar';
import { useAuth } from './context/AuthContext';
import './styles/App.css'; // Make sure this includes the sidebar styles

function App() {
  const { isAuthenticated, loading } = useAuth();

  return (
    <div className="app-container">
      <Navbar />
      <div className="content-wrapper">
        {!loading && isAuthenticated && <Sidebar />}
        <main className={isAuthenticated ? 'main-content' : 'full-content'}>
          <Outlet />
        </main>
      </div>
    </div>
  );
}

export default App;
